document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;

  // Mobile mega navigation
  const nav = document.querySelector('[data-main-navigation]');
  const navToggle = document.querySelector('[data-mobile-menu-toggle]');
  const navClosers = document.querySelectorAll('[data-mobile-menu-close]');
  const navBackdrop = document.querySelector('.mobile-nav-backdrop');
  const setNav = (open) => {
    if (!nav) return;
    nav.classList.toggle('is-open', open);
    navBackdrop?.classList.toggle('is-open', open);
    navToggle?.setAttribute('aria-expanded', String(open));
    body.style.overflow = open ? 'hidden' : '';
  };
  navToggle?.addEventListener('click', () => setNav(true));
  navClosers.forEach((button) => button.addEventListener('click', () => setNav(false)));

  // Collection filter drawer
  const filterPanel = document.querySelector('[data-filter-panel]');
  const filterBackdrop = document.querySelector('.filter-backdrop');
  const filterToggle = document.querySelector('[data-filter-toggle]');
  const setFilters = (open) => {
    if (!filterPanel) return;
    filterPanel.classList.toggle('is-open', open);
    filterBackdrop?.classList.toggle('is-open', open);
    filterToggle?.setAttribute('aria-expanded', String(open));
    body.style.overflow = open ? 'hidden' : '';
  };
  filterToggle?.addEventListener('click', () => setFilters(true));
  document.querySelectorAll('[data-filter-close]').forEach((button) => button.addEventListener('click', () => setFilters(false)));

  // Product image gallery
  const galleryMain = document.querySelector('[data-gallery-main] img');
  document.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      if (!galleryMain) return;
      galleryMain.removeAttribute('srcset');
      galleryMain.removeAttribute('sizes');
      galleryMain.src = thumb.dataset.image;
      galleryMain.alt = thumb.dataset.alt || '';
      document.querySelectorAll('[data-gallery-thumb]').forEach((item) => item.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });
  });

  // Quantity stepper
  document.querySelectorAll('[data-quantity-stepper]').forEach((stepper) => {
    const input = stepper.querySelector('input');
    stepper.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
      input.value = Math.max(Number(input.min || 1), Number(input.value || 1) - 1);
    });
    stepper.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
      input.value = Number(input.value || 1) + 1;
    });
  });

  // Variant price update
  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const price = document.querySelector('[data-product-price]');
      const compare = document.querySelector('[data-product-compare]');
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (compare) {
        compare.textContent = option.dataset.compare || '';
        compare.hidden = !option.dataset.compare;
      }
    });
  });

  // Recently viewed products (stored locally in the shopper's browser)
  const recentScript = document.querySelector('[data-recent-product]');
  if (recentScript) {
    try {
      const current = JSON.parse(recentScript.textContent);
      const key = 'tempaRecentlyViewed';
      const existing = JSON.parse(localStorage.getItem(key) || '[]').filter((item) => item.handle !== current.handle);
      existing.unshift(current);
      localStorage.setItem(key, JSON.stringify(existing.slice(0, 12)));
    } catch (e) {}
  }

  const recentContainer = document.querySelector('[data-recently-viewed]');
  if (recentContainer) {
    try {
      const key = 'tempaRecentlyViewed';
      const currentHandle = recentContainer.dataset.currentHandle;
      const limit = Number(recentContainer.dataset.limit || 4);
      const products = JSON.parse(localStorage.getItem(key) || '[]').filter((item) => item.handle !== currentHandle).slice(0, limit);
      if (products.length) {
        recentContainer.innerHTML = products.map((product) => `
          <article class="product-card">
            <a class="product-card__media" href="${escapeHtml(product.url)}">${product.image ? `<img loading="lazy" src="${escapeHtml(product.image)}" alt="${escapeHtml(product.title)}">` : '<div class="product-card__placeholder">TEMPA TCG</div>'}</a>
            <div class="product-card__body">
              ${product.set ? `<div class="product-card__vendor">${escapeHtml(product.set)}</div>` : ''}
              <h3><a href="${escapeHtml(product.url)}">${escapeHtml(product.title)}</a></h3>
              <div class="product-card__pricing"><span class="price">${escapeHtml(product.price)}</span></div>
              ${product.condition ? `<span class="badge badge--condition">${escapeHtml(product.condition)}</span>` : ''}
              <a class="btn btn--accent" href="${escapeHtml(product.url)}">View product</a>
            </div>
          </article>`).join('');
        recentContainer.closest('[data-recently-viewed-section]')?.removeAttribute('hidden');
      }
    } catch (e) {}
  }

  // Buylist row builder + contact-form serialization
  const buylistTable = document.querySelector('[data-buylist-table]');
  const addBuylist = document.querySelector('[data-buylist-add]');
  const buylistForm = document.querySelector('#BuylistForm');
  const bindRemove = (scope = document) => {
    scope.querySelectorAll('[data-buylist-remove]').forEach((button) => {
      if (button.dataset.bound) return;
      button.dataset.bound = 'true';
      button.addEventListener('click', () => {
        const rows = document.querySelectorAll('[data-buylist-row]');
        if (rows.length > 1) button.closest('[data-buylist-row]')?.remove();
      });
    });
  };
  bindRemove();
  addBuylist?.addEventListener('click', () => {
    const first = buylistTable?.querySelector('[data-buylist-row]');
    if (!first) return;
    const clone = first.cloneNode(true);
    clone.querySelectorAll('input').forEach((input) => { input.value = input.type === 'number' && input.dataset.field === 'Quantity' ? '1' : ''; input.required = false; });
    clone.querySelectorAll('select').forEach((select) => { select.selectedIndex = 0; });
    clone.querySelector('[data-buylist-remove]')?.removeAttribute('data-bound');
    buylistTable.appendChild(clone);
    bindRemove(clone);
  });
  buylistForm?.addEventListener('submit', () => {
    const rows = [...buylistForm.querySelectorAll('[data-buylist-row]')];
    const output = rows.map((row, index) => {
      const fields = [...row.querySelectorAll('[data-field]')].map((field) => `${field.dataset.field}: ${field.value || '-'}`);
      return `${index + 1}. ${fields.join(' | ')}`;
    }).join('\n');
    const outputField = buylistForm.querySelector('[data-buylist-output]');
    if (outputField) outputField.value = output;
  });
});

function escapeHtml(value) {
  return String(value ?? '')
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');
}
